export const ACCOUNT_MENU_TOGGLE = 'ACCOUNT_MENU_TOGGLE';
